module.exports = __webpack_public_path__ + "img/31.b156f6ce.jpg";